import _ from 'underscore'
export default {
  data() {
    return {
      isInActive: true,
    }
  },
  created() {
    this.proxyData()
    this.proxyMethods()
  },
  activated() {
    this.isInActive = true
  },
  deactivated(){
    this.isInActive = false
  },
  methods: {
    proxyData() {
      const vm = this
      const keys = Object.keys(this.$data)
      keys.forEach(k => {
        Object.defineProperty(vm, k, {
          enumerable: true,
          configurable: true,
          get: function () {
            return this.$data[k]
          },
          set: function (val) {
            if (k !== 'isInActive' && !this.isInActive) {
              console.log(`deactivated 的时候不允许改动数据${k}`)
              return
            }
            this.$data[k] = val
          }
        })
      })
    },
    proxyMethods() {

      if (!_.isEmpty(this.$options.methods)) {
        const vm = this
        const methodsKeys = Object.keys(this.$options.methods)
        methodsKeys.forEach(key => {
          Object.defineProperty(vm, key, {
            enumerable: true,
            configurable: true,
            get: function() {
              if (key !== 'proxyData' && key !== 'proxyMethods') {
                if (!vm.isInActive) {
                  return () => {}
                } else {
                  return vm.$options.methods[key].bind(vm)
                }
              } else {
                return vm.$options.methods[key].bind(vm)
              }
            },
          })


        })
      }
    },
  }
}
